import SuccessAlertDialog from '@anm/components/subscription/SuccessAlertDialog';
import { useCallback, useEffect, FC } from 'react';

import useResetAfterSuccessUpgrade from '../PricingSubscriptionContent/hooks/useResetAfterSuccessUpgrade';
import useUpdateUserInfoHandler from '../PricingSubscriptionContent/hooks/useUpdateUserInfoHandler';

type SuccessAlertProps = {
  alertMessage: string;
  onClose: () => void;
};
const SuccessAlert: FC<SuccessAlertProps> = ({ alertMessage, onClose }) => {
  const handleInfoUpdate = useUpdateUserInfoHandler();
  const resetAfterSuccessUpgrade = useResetAfterSuccessUpgrade();

  const handleCloseAlert = useCallback(() => {
    onClose();
    resetAfterSuccessUpgrade();
  }, []);

  useEffect(() => {
    handleInfoUpdate();
  }, []);

  return (
    <SuccessAlertDialog
      message={alertMessage}
      onCloseAlert={handleCloseAlert}
      onButtonClick={handleCloseAlert}
    />
  );
};

export default SuccessAlert;
